module.exports = __webpack_public_path__ + "img/THV_Bereitschaft.b84fa5d1.svg";